import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

interface RevokePatDialogProps {
  open: boolean
  tokenLabel: string
  onClose: () => void
  onConfirm: () => void
}

export default function RevokePatDialog({ open, tokenLabel, onClose, onConfirm }: RevokePatDialogProps) {
  return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete token</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete your <strong>{tokenLabel || "token"}</strong>? This immediately revokes the token and cannot be undone. You can create a new one afterwards.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">Delete token</Button>
    </DialogActions>
  </Dialog>
}
